<template>
    <div class="about-product--col--section">
        <div class="about-product--col--section--title">
            <span class="scroll-behavior-placeholder" id="vase-hodnotenia"></span>
            Vaše hodnotenia
        </div>

        <div v-if="product" class="about-product--col--section--content">
            <div class="evaluations">
                <div class="evaluations--header">
                    <div class="add-evaluation">
                        <div class="add-evaluation--rating" :class="evaluationMarkHover ? `mark-hover-${evaluationMarkHover}` : `mark-${evaluationMark}`">
                            <div class="add-evaluation--rating--box" v-for="(rating, index) in ratings" :key="index" @click="selectEvaluationMark( rating )" @mouseenter="evaluationMarkHover = rating" @mouseleave="evaluationMarkHover = null">
                                <EvaluationStar />
                            </div>
                        </div>

                        <div class="add-evaluation--action">
                            <span class="btn btn-action-blue btn-wide" @click="showEvaluationPopup = true">
                                <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.15 2.5625C12.6194 2.5625 13 2.94306 13 3.4125C13 3.88194 12.6194 4.2625 12.15 4.2625H6C5.93242 4.26249 5.86683 4.2853 5.81383 4.32722C5.76083 4.36915 5.72354 4.42774 5.708 4.4935L5.7 4.5625V20.5625C5.69999 20.6301 5.7228 20.6957 5.76472 20.7487C5.80665 20.8017 5.86524 20.839 5.931 20.8545L6 20.8625H18C18.0676 20.8625 18.1332 20.8397 18.1862 20.7978C18.2392 20.7559 18.2765 20.6973 18.292 20.6315L18.3 20.5625V11.4125C18.3 10.9431 18.6806 10.5625 19.15 10.5625C19.6194 10.5625 20 10.9431 20 11.4125V20.5625C20 21.0929 19.7893 21.6016 19.4142 21.9767C19.0391 22.3518 18.5304 22.5625 18 22.5625H6C5.46957 22.5625 4.96086 22.3518 4.58579 21.9767C4.21071 21.6016 4 21.0929 4 20.5625V4.5625C4 4.03207 4.21071 3.52336 4.58579 3.14829C4.96086 2.77321 5.46957 2.5625 6 2.5625H12.15ZM11.5 16.5625C11.7761 16.5625 12 16.7864 12 17.0625C12 17.3386 11.7761 17.5625 11.5 17.5625H8.5C8.22386 17.5625 8 17.3386 8 17.0625C8 16.7864 8.22386 16.5625 8.5 16.5625H11.5ZM13.5 14.5625C13.7761 14.5625 14 14.7864 14 15.0625C14 15.3386 13.7761 15.5625 13.5 15.5625H8.5C8.22386 15.5625 8 15.3386 8 15.0625C8 14.7864 8.22386 14.5625 8.5 14.5625H13.5ZM18.314 1.7535C18.9686 1.09613 20.0325 1.09502 20.6885 1.751L20.75 1.81246C21.4399 2.5024 21.4387 3.62139 20.7472 4.30983L13.463 11.5625H11V9.2355C11 9.1145 16.7 3.3815 18.314 1.7535ZM19.8311 2.73111C19.6481 2.54949 19.3526 2.55024 19.1706 2.73279L14.078 7.8385L13.307 8.6475L12.407 9.5945L12.307 9.7055V10.2625H12.934L19.8316 3.39443C20.0154 3.21143 20.0152 2.91381 19.8311 2.73111Z" fill="currentColor"/>
                                </svg>
                                Pridať hodnotenie
                            </span>
                        </div>
                    </div>
                </div>

                <div class="evaluations--preview">
                    <div class="evaluations-preview">
                        <div class="evaluations-preview--box">
                            <h2>{{ product.average_rating_formatted }} <small>/ 5</small></h2>

                            <EvaluationResult :ratingExtraClass="`mark-${product.average_rating_rounded}`" />

                            <h5>{{ evaluationsCount }}</h5>
                        </div>

                        <div class="evaluations-preview--box">
                            <div class="evaluation-marks">
                                <div class="evaluation-mark" v-for="(rating, index) in ratingsReverse" :key="index">
                                    <div class="evaluation-mark--box">{{ rating }}</div>

                                    <div class="evaluation-mark--box">
                                        <div class="evaluation-progressbar">
                                            <span :style="`width: ${groupedEvaluations[ rating ] ? groupedEvaluations[ rating ].length / product.evaluations.length * 100 : 0}%`"></span>
                                        </div>
                                    </div>

                                    <div class="evaluation-mark--box">
                                        {{ groupedEvaluations[ rating ] ? groupedEvaluations[ rating ].length : 0 }} x
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="product.evaluations.length" class="evaluations--body">
                    <div class="product-reviews">
                        <AuthorReview v-for="evaluation in product.evaluations" :key="evaluation.id" :evaluation="evaluation" @updateLikes="evaluation.likes = $event" />
                    </div>
                </div>
            </div>
        </div>

        <EvaluationPopup v-if="showEvaluationPopup" :product_id="product_id" :user="user" :evaluationMark="evaluationMark" @closeEvaluationPopup="closeEvaluationPopup( $event )" />
    </div>
</template>

<script>
    import AuthorReview from './AuthorReview'
    import EvaluationStar from './EvaluationStar'
    import EvaluationResult from './EvaluationResult'
    import EvaluationPopup from '../popups/EvaluationPopup'

    export default {
        components: {
            AuthorReview,
            EvaluationStar,
            EvaluationResult,
            EvaluationPopup
        },
        props: {
            product_id: {
                type: Number
            },
            user: {
                type: Object
            }
        },
        data() {
            return {
                ratings: [1, 2, 3, 4, 5],
                ratingsReverse: [5, 4, 3, 2, 1],
                product: null,
                groupedEvaluations: null,
                evaluationMark: 0,
                evaluationMarkHover: null,
                showEvaluationPopup: false
            }
        },
        computed: {
            evaluationsCount() {
                let word = ' hodnotení'

                if ( this.product.evaluations.length === 1 ) word = ' hodnotenie'
                if ( [2, 3, 4].includes( this.product.evaluations.length ) ) word = ' hodnotenia'

                return this.product.evaluations.length + word
            }
        },
        created() {
            this.loadData()
        },
        methods: {
            loadData() {
                axios.get(`/api/shop/product/${this.product_id}/evaluations`)
                .then( response => { 
                    this.product = response.data.data.product
                    this.groupedEvaluations = response.data.data.groupedEvaluations

                }).catch( errors => { alert('Woops, nepodarilo sa načítať dáta!') })
            },
            selectEvaluationMark( rating ) {
                this.evaluationMark !== rating ? this.evaluationMark = rating : this.evaluationMark = 0

                if ( this.evaluationMark === rating ) this.showEvaluationPopup = true
            },
            closeEvaluationPopup( withReloadData ) {
                this.evaluationMark = 0
                this.showEvaluationPopup = false

                if ( withReloadData ) this.loadData()
            }
        },
    }
</script>